module.exports = __webpack_public_path__ + "static/img/2015@2x.b0036df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2015@2x.png
// module id = t62i
// module chunks = 1